/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SignaturePositionSchemaDto } from './SignaturePositionSchemaDto';
import {
    SignaturePositionSchemaDtoFromJSON,
    SignaturePositionSchemaDtoFromJSONTyped,
    SignaturePositionSchemaDtoToJSON,
} from './SignaturePositionSchemaDto';

/**
 * 
 * @export
 * @interface SaveSignaturePositionsDto
 */
export interface SaveSignaturePositionsDto {
    /**
     * 
     * @type {Array<SignaturePositionSchemaDto>}
     * @memberof SaveSignaturePositionsDto
     */
    signaturePositions?: Array<SignaturePositionSchemaDto> | null;
}

/**
 * Check if a given object implements the SaveSignaturePositionsDto interface.
 */
export function instanceOfSaveSignaturePositionsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SaveSignaturePositionsDtoFromJSON(json: any): SaveSignaturePositionsDto {
    return SaveSignaturePositionsDtoFromJSONTyped(json, false);
}

export function SaveSignaturePositionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveSignaturePositionsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signaturePositions': !exists(json, 'signaturePositions') ? undefined : (json['signaturePositions'] === null ? null : (json['signaturePositions'] as Array<any>).map(SignaturePositionSchemaDtoFromJSON)),
    };
}

export function SaveSignaturePositionsDtoToJSON(value?: SaveSignaturePositionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signaturePositions': value.signaturePositions === undefined ? undefined : (value.signaturePositions === null ? null : (value.signaturePositions as Array<any>).map(SignaturePositionSchemaDtoToJSON)),
    };
}

